export default __webpack_public_path__ + "static/SuisseIntl-Thin-efc39b0e97db99611f18253bf911648b.woff2";